interface IFingerprintPayload {
  custom?: { sdkErrorCode?: unknown };
  body?: {
    trace?: { exception?: { description?: unknown; message?: unknown } };
    message?: { body?: unknown };
  };
}

const asText = (value: unknown): string =>
  typeof value === 'string' ? value : '';

// Rollbar's default fingerprint hashes the filename and method name of every
// stack frame. The wallaby-cash SDK is minified, so its method names change
// with each build, and one SDK error splits into one Rollbar item per build
// (RWA-310). The SDK error code in `custom.sdkErrorCode` is stable across
// builds. The fingerprint is the report title, the code and the exception
// message: one item per call site, SDK error code and message. The message
// keeps two different failures that share a generic code in two items. Rollbar
// hashes a fingerprint longer than 40 characters. A report without
// `custom.sdkErrorCode` keeps the default grouping.
export function getErrorCodeFingerprint(
  payload: IFingerprintPayload
): string | undefined {
  const sdkErrorCode = payload.custom?.sdkErrorCode;
  if (typeof sdkErrorCode !== 'string' || !sdkErrorCode) return undefined;

  const exception = payload.body?.trace?.exception;
  const title =
    asText(exception?.description) || asText(payload.body?.message?.body);

  return [title, sdkErrorCode, asText(exception?.message)].join('|');
}
